import { atomFactory } from '@utils/recoil/atomFactory';
import { RECOIL_KEYS, RECOIL_PERSIST_KEYS } from '@utils/constants';

export const {
    atom: unreadNotificationCountAtom,
    hook: useUnreadNotificationCountAtom,
} = atomFactory<number>({
    key: RECOIL_KEYS.UNREAD_NOTIFICATIONS_COUNT,
    persistKey: RECOIL_PERSIST_KEYS.UNREAD_NOTIFICATIONS_COUNT,
    default: 0,
});
